import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'limitTo'
})
export class TruncatePipe implements PipeTransform {

  transform(value: string, limit: number): string {
    let trail = '...';

    if (value) {
      return value.length > limit ? value.substring(0, limit) + trail : value;
    }
    return null;
  }
}


// WEBPACK FOOTER //
// ./src/pipes/limit.pipe.ts